<template>
  <div
    class="dropdown-wrapper enext-input"
    :class="[
      rules && rules.length ? 'enext-input--validable' : '',
      errorMessage ? 'invalid' : '',
      $attrs?.class ? $attrs.class : ''
    ]"
  >
    <template v-if="$attrs.name">
      <template v-if="$refs.kendoelement">
        <input
          v-for="(value, index) in $refs.kendoelement.value"
          :key="index"
          :value="value"
          type="hidden"
          :name="$attrs.name + '[]'"
        >
      </template>
      <input
        v-else
        :name="$attrs.name + '[]'"
        type="hidden"
      >
    </template>
    <!-- class="dropdown" -->
    <kendo-multiselect
      :class="cssClasses"
      v-bind="customAttrs"
      :rounded="null"
      :tags-rounded="'small'"
      @filterchange="filterChange"
      @open="handleOnOpen"
      @close="handleOnClose"
      @change="checkSelection"
      :data-items="items"
      :name="uuid+'dropdown'"
      :auto-close="false"
      :opened="opened"
      :popup-settings="popupSettings"
      ref="kendoelement"
    >
      <template
        v-for="(_, slot) of $slots"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
    </kendo-multiselect>
    <ErrorMessage
      :error-message="errorMessage"
    />
  </div>
</template>

<script>
import {MultiSelect} from '@progress/kendo-vue-dropdowns'
import dropdownMixin from '~/mixins/dropdown'
import ErrorMessage from '~/components/input-components/ErrorMessage'

export default {
  name: 'MultiSelectDropDown',
  components: {
    ErrorMessage,
    'kendo-multiselect': MultiSelect
  },
  mixins: [dropdownMixin],
  computed: {
    customAttrs() {
      let attrs = {...this.$attrs, class: ''}
      return attrs
    }
  },
  methods: {
    async checkSelection(event) {
      this.opened = false
      let value = event.value
      await this.$nextTick()
      if (!this.items?.every(i => value.includes(i))) {
        this.opened = true
      }
    },
    handleOnOpen() {
      this.opened = true
      this.popupSettings = {animate: false}
      this.onOpen()
    },
    handleOnClose() {
      this.opened = false
      this.popupSettings = {animate: true}
      this.onClose()
    }
  },
  data() {
    return {
      opened: false,
      popupSettings: {animate: true, width: 400}
    }
  }
}
</script>
